import type { OAuth2Config, OAuth2Provider } from '@edusense/shared-auth-core'
import { buildAdminOAuthConfig, getAdminAuthServerUrl } from './adminOAuth'

type LoginFn = (
  provider: OAuth2Provider,
  config?: Partial<OAuth2Config>,
  prompt?: string,
  postLoginRedirect?: string,
) => void

type ContinueAdminPortalLoginOptions = {
  authServerUrl?: string
  login?: LoginFn
}

/**
 * Starts a fresh PKCE authorization request after the server-side MFA session
 * has been verified. This intentionally keeps the current admin session and
 * does not force another credential prompt.
 */
export const continueAdminPortalLogin = async (
  postLoginRedirect: string,
  options: ContinueAdminPortalLoginOptions = {},
): Promise<void> => {
  const authServerUrl = options.authServerUrl || getAdminAuthServerUrl()
  const oauthConfig = buildAdminOAuthConfig({ authServerUrl })
  const login = options.login
    || (await import('@edusense/shared-auth-core')).loginWithRedirect

  login('internal', oauthConfig, undefined, postLoginRedirect)
}
